<template>
  <div class="d-flex align-items-center ab-test__tooltip" :class="dynamicClass" v-popover:tooltip="jsTooltip ? $t('abTest.tooltip') : undefined">
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.335 6.5C13.335 6.96116 12.9612 7.335 12.5 7.335H10.5C9.7627 7.335 9.165 6.7373 9.165 6V1.67H2.17V16.33H13.83V4.69174L10.835 1.69674V5.665H12.5C12.9612 5.665 13.335 6.03884 13.335 6.5ZM2 0C1.17157 0 0.5 0.671573 0.5 1.5V16.5C0.5 17.3284 1.17157 18 2 18H14C14.8284 18 15.5 17.3284 15.5 16.5V4.62132C15.5 4.2235 15.342 3.84197 15.0607 3.56066L11.9393 0.43934C11.658 0.158035 11.2765 0 10.8787 0H2Z" fill="#666666" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00203 7.18054C6.297 6.35289 7.46726 6.35224 7.76316 7.17956L9.44047 11.8694L9.9958 13.4314C10.1503 13.8659 9.92327 14.3433 9.48876 14.4978C9.05425 14.6523 8.57677 14.4253 8.42229 13.9908L8.06438 12.9841H5.70485L5.34192 13.9936C5.1859 14.4275 4.70763 14.6528 4.27367 14.4968C3.8397 14.3408 3.61438 13.8625 3.7704 13.4286L4.33118 11.8687L4.33196 11.8666L6.00203 7.18054ZM6.30176 11.3141H7.46828L6.88399 9.68039L6.30176 11.3141Z" fill="#666666" />
    </svg>

    <template v-if="!jsTooltip">
      <span class="ab-test__tooltip-arrow">&nbsp;</span>
      <span class="border-radius text-dark-high body-12-regular py-4px px-1 ab-test__tooltip-content" v-html="$t('abTest.tooltip')"></span>
    </template>
  </div>
</template>

<script>
export default {
  name: "AbTestingTooltip",
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    jsTooltip: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    dynamicClass() {
      return {
        "mr-1": !this.small,
        "small": this.small,
      }
    }
  }
}
</script>

<style lang="scss">
.ab-test {
  &__tooltip {
    position: relative;

    &-arrow, &-content {
      position: absolute;
      transform: translateX(-50%);
      left: 50%;
      display: none;
      z-index: 100;
    }

    &:hover {
      .ab-test__tooltip {
        &-arrow, &-content {
          display: block;
        }
      }
    }

    &-arrow {
      bottom: -8px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 4px solid $dark1;
      width: 0;
    }

    &-content {
      background-color: $dark1;
      min-width: 136px;
      top: calc(100% + 8px);
    }

    &.small {
      width: 11px;
      height: 13px;
      margin-right: 6px;
    }
  }
}
</style>
